<template>
    <div ref="scrollActivity" class="white-box mt-3">
        <div class="data-group">
            <M3FormTitle title="Activități & subactivități" :checked="completed"></M3FormTitle>
            <div class="adauga-asociat mb-5 mt-2">
                <div>
                    <p class="title"><strong>Îți propunem următoarele Activități și Subactivități</strong></p>
                </div>
                <div class="add-button" :class="{'button-absolute' : checkScroll}" @click="addActivity()">
                    <p>Adaugă activitate nouă</p>
                    <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
                </div>
            </div>
            <div v-if="!innovativeProductExists() && !innovativeProductConfirmed">
                <div class="yellow-warning">
                    <img src="@/assets/images/M3/M3Sketch/info-icon.png">
                    <div class="flexed-warn">
                        <p><a href="javascript:void(0)" @click="addInnovativeProductSubactivity()">Adaugă</a> Lansarea unui produs / serviciu nou - inovativ.</p>
                        <div class="add-button" @click="toggleInnovativeConfirmed()">
                            <p>Am adăugat</p>
                            <b-icon-check-circle font-scale="1.2"></b-icon-check-circle>
                        </div>
                    </div>
                </div>
            </div>
            <validation-observer #default="{ invalid }" ref="titleObserver">
                <b-form id="activitateContainer" @submit.prevent>
                    <div v-for="(activitate, key) in activities" :key="key" class="activitate">
                        <div class="header" :class="activitate.green ? 'green' : '' || activitate.purple ? 'purple' : ''">
                            <span class="title" :class="editing.activitate === key && editing.subActivitate === null ? 'flex align-center fixed-width' : ''">
                                <strong :class="editing.activitate === key && editing.subActivitate === null ? 'flex align-center' : ''">Activitatea
                                    <span>{{ key+1 }} </span>
                                    <span>- &nbsp;</span>
                                </strong>
                                <span v-if="editing.activitate !== key || editing.subActivitate != null ">{{ activitate.title }}</span>
                                <validation-provider
                                    v-else-if="editing.activitate === key && editing.subActivitate === null "
                                    #default="{ errors }"
                                    rules="required|max:110"
                                    name="titlu"
                                    class="position-relative error-input-custom"
                                >
                                    <b-form-input
                                        :id="'inputActivity-'+activitate.id"
                                        v-model="activitate.title"
                                        :state="errors.length > 0 ? false : null"
                                        @keyup.enter="saveEdit(activitate.title)"
                                    ></b-form-input>
                                    <small class="text-danger" style="position: inherit; right: 0;">{{ errors[0] }}</small>
                                </validation-provider>
                            </span>
                            <div class="actions">
                                <b-icon-plus-circle :id="'addActivity-' + activitate.id" font-scale="1.4" @click="addActivityChild(activitate.id)"></b-icon-plus-circle>
                                <b-tooltip :target="'addActivity-' + activitate.id" triggers="hover" placement="top">Adaugă subactivitate</b-tooltip>
                                <b-icon-pencil-square v-if="editing.activitate !== key || editing.subActivitate != null" :id="'startEditActivity-' + activitate.id" font-scale="1.4" @click="toggleEdit(key,null, activitate.id)"></b-icon-pencil-square>
                                <b-icon-check-circle-fill v-else-if="editing.activitate === key && editing.subActivitate === null" :id="'endEditActivity-' + activitate.id" font-scale="1.2" :class="invalid ? 'pointer-none' : ''" @click="saveEdit(activitate.title)"></b-icon-check-circle-fill>
                                <b-tooltip v-if="editing.activitate !== key || editing.subActivitate != null" :target="'startEditActivity-' + activitate.id" triggers="hover" placement="top">Modifică activitatea</b-tooltip>
                                <b-tooltip v-else-if="editing.activitate === key && editing.subActivitate === null" :target="'endEditActivity-' + activitate.id" triggers="hover" placement="top">Salvează modificările</b-tooltip>
                                <b-icon-trash :id="'deleteActivity-' + activitate.id" font-scale="1.4" @click="deleteActivity({id: activitate.id, parent: true})"></b-icon-trash>
                                <b-tooltip :target="'deleteActivity-' + activitate.id" triggers="hover" placement="top">Șterge activitatea</b-tooltip>
                            </div>
                        </div>
                        <div v-for="(subactivitate, key2) in activitate.childrens" :key="key2" class="subactivitate">
                            <div class="sub-item" :class="subactivitate.title == 'Lansarea unui produs / serviciu nou - inovativ' ? 'green' : '' || subactivitate.purple ? 'purple' : ''">
                                <span class="title" :class="editing.activitate === key && editing.subActivitate === key2 ? 'flex align-center fixed-width-small' : ''">
                                    <strong>{{ key+1 }}.{{ key2+1 }}. -</strong>
                                    <span v-if="editing.subActivitate != key2 || editing.activitate != key " class="ml-2"> {{ subactivitate.title }}</span>

                                    <validation-provider
                                        v-else-if="editing.activitate === key && editing.subActivitate === key2"
                                        #default="{ errors }"
                                        rules="required|max:110"
                                        class="position-relative error-input-custom"
                                        name="titlu"
                                    >
                                        <b-form-input
                                            :id="'inputActivity-'+subactivitate.id"
                                            v-model="subactivitate.title"
                                            :state="errors.length > 0 ? false : null"
                                            @keyup.enter="saveEdit(subactivitate.title)"
                                        ></b-form-input>
                                        <small class="text-danger" style="position: inherit; right: 0;">{{ errors[0] }}</small>
                                    </validation-provider>
                                </span>
                                <div class="actions">
                                    <b-icon-card-heading :id="'gantt-' + subactivitate.id" font-scale="1.2" :class="gantt_editing === subactivitate.id ? 'gantt-active' : ''" @click="toggleGant(subactivitate.id)"></b-icon-card-heading>
                                    <b-tooltip :target="'gantt-' + subactivitate.id" triggers="hover" placement="top">Modifică perioada</b-tooltip>
                                    <b-icon-pencil-square v-if=" editing.subActivitate != key2 || editing.activitate != key" :id="'startEditSubactivity-' + subactivitate.id" font-scale="1.2" @click="toggleEdit(key,key2, subactivitate.id)"></b-icon-pencil-square>
                                    <b-icon-check-circle-fill v-else-if="editing.activitate === key" :id="'endEditSubactivity-' + subactivitate.id" font-scale="1.2" :class="invalid ? 'pointer-none' : ''" @click="saveEdit(subactivitate.title)"></b-icon-check-circle-fill>
                                    <b-tooltip v-if=" editing.subActivitate != key2 || editing.activitate != key" :target="'startEditSubactivity-' + subactivitate.id" triggers="hover" placement="top">Modifică subactivitatea</b-tooltip>
                                    <b-tooltip v-else-if="editing.activitate === key" :target="'endEditSubactivity-' + subactivitate.id" triggers="hover" placement="top">Salvează modificările</b-tooltip>
                                    <b-icon-trash :id="'deleteSubactivity-' + subactivitate.id" font-scale="1.2" @click="deleteActivity({id: subactivitate.id, parent: false, parentKey: key})"></b-icon-trash>
                                    <b-tooltip :target="'deleteSubactivity-' + subactivitate.id" triggers="hover" placement="top">Șterge subactivitatea</b-tooltip>
                                </div>
                            </div>
                            <div class="sub-item-margin gantt-slider" :class="gantt_editing === subactivitate.id ? 'visible-gantt' : 'invisible-gantt'">
                                <vue-range-slider
                                    v-if="gantt_editing === subactivitate.id"
                                    v-model="subactivitate.date"
                                    :min="minSlider"
                                    :max="maxSlider"
                                    :piecewise="true"
                                    :min-range="1"
                                    :piecewise-label="true"
                                    tooltip="always"
                                    :tooltip-style="{'display': 'none'}"
                                    :step="1"
                                    :tooltip-merge="tooltipMerge"
                                    :enable-cross="enableCross"
                                    @drag-end="buildGantt()"
                                ></vue-range-slider>
                                <div v-if="gantt_editing === subactivitate.id" class="flex mt-5 space-between">
                                    <p><strong>Luna</strong> (început/final)</p>
                                    <p>Durata activității: <strong>{{ subactivitate.date[1] - subactivitate.date[0] }} luni</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mt-5">
                    <div>
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            style="margin-top: 0"
                            :disabled="disableSaveButton"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </div>
                </b-form>
            </validation-observer>
        </div>
        <p id="scrollAuxiliary" style="display: none; margin-top:100px">&nbsp;</p>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import { BForm, BFormInput, BIconPencilSquare, BIconTrash, BIconCheckCircleFill, BFormCheckbox, BIconPlusCircle, BIconPlusCircleFill, BIconCardHeading, BTooltip, BIconCheckCircle} from "bootstrap-vue";
    import draggable from 'vuedraggable'
    import 'vue-range-component/dist/vue-range-slider.css'
    import VueRangeSlider from 'vue-range-component'
    import colorsJSON from './colors.json'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            BIconPencilSquare,
            BIconTrash,
            BIconCheckCircleFill,
            BFormCheckbox,
            BIconPlusCircle,
            BIconCheckCircle,
            M3FormTitle,
            BIconCardHeading,
            BIconPlusCircleFill,
            BTooltip,
            ValidationProvider,
            ValidationObserver,
            draggable,
            VueRangeSlider,
        },
        props: {
            activitati: null,
            checkScroll:{
                type:Boolean,
                default:false
            },
        },
        data() {
            return {
                completed: false,
                disableSaveButton: false,
                editing: {
                    activitate:null,
                    subActivitate:null
                },
                selectedAcquisitions: null,
                minSlider:1,
                maxSlider:19,
                enableCross : false,
                tooltipMerge : true,
                gantt_editing: false,
                innovativeProductConfirmed: false,
                gantt: [],
                activities: [
                    {
                        id: 0,
                        title: 'MANAGEMENTUL PROIECTULUI',
                        number: 1,
                        childrens: [
                            {
                                id: 1,
                                title: 'Managementul proiectului',
                                number: 1,
                                date: [5,14],
                                parentId: 0,
                            },
                            {
                                id: 2,
                                title: 'Publicitate și informare aferente proiectului',
                                number: 2,
                                date: [5,14],
                                parentId: 0,
                            },
                            {
                                id: 3,
                                title: 'Lansarea unui produs / serviciu nou - inovativ',
                                number: 3,
                                parentId: 0,
                                date: [5,14],
                                green: true,
                            },
                        ]
                    },
                    {
                        id: 4,
                        title: 'DOTAREA CU ACTIVE CORPORALE, NECORPORALE',
                        number: 2,
                        childrens: [
                            {
                                id: 5,
                                title: 'Dotarea cu active corporale',
                                number: 1,
                                date: [5,14],
                                parentId: 4,
                            },
                            {
                                id: 6,
                                title: 'Dotarea cu active necorporale',
                                number: 2,
                                date: [5,14],
                                parentId: 4,
                            },
                        ]
                    },
                    {
                        id: 7,
                        title: 'AUDIT FINAL AL PROIECTULUI',
                        number: 3,
                        childrens: [
                            {
                                id: 8,
                                title: 'Activitatea de audit final al proiectului',
                                number: 1,
                                date: [5,14],
                                parentId: 7,
                            },
                        ]
                    },
                ],
                colors: colorsJSON,
                nextId: 1
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.activitati;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            allData: {
                handler () {
                    if(this.allData){
                        if(this.allData.m3_project && this.allData.m3_project.activities && this.allData.m3_project.activities.activities && this.allData.m3_project.activities.activities.length){
                            this.activities = this.allData.m3_project.activities.activities;
                            this.activities.forEach(activity => {
                                activity.childrens.forEach(child => {
                                    if(!(child.date && child.date.length)){
                                        child.date = [5,14];
                                    }
                                })
                            })
                        }
                        this.innovativeProductConfirmed = localStorage.getItem('innovativeProductConfirmed' + this.allData.id);
                        this.checkIdsDuplicated();
                        this.buildGantt();
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.$route.query && this.$route.query.reset === 'true')
                this.completed = false;


        },
        methods: {
            buildGantt() {
                if(this.gantt.length) {
                    this.gantt = []
                }
                let colorIndex = 0;
                this.activities.forEach(activity => {

                    let color = this.colors[colorIndex % 7].color;
                    colorIndex++;

                    let min = 19;
                    let max = 0;

                    activity.childrens.forEach(child => {
                        if(min > child.date[0])
                            min = child.date[0]

                        if(max < child.date[1])
                            max = child.date[1]
                    })

                    this.gantt.push({
                        activity: activity,
                        fillColor: color,
                        date: [
                            min,
                            max
                        ]
                    });
                })
                this.$emit('gantBuilt', this.gantt)
            },
            toggleInnovativeConfirmed() {
                this.innovativeProductConfirmed = true
                localStorage.setItem('innovativeProductConfirmed' + this.allData.id, true)
            },
            saveEdit(text) {
                if(text.length > 0){
                    this.editing.activitate =  null;
                    this.editing.subActivitate = null;
                }
            },
            toggleEdit(indexActivitate,indexSubActivitate, id) {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else{
                    this.editing.activitate =  indexActivitate
                    this.editing.subActivitate = indexSubActivitate!=null ? indexSubActivitate : null;
                    setTimeout(() => {
                        document.getElementById('inputActivity-' + id).focus();
                    }, 100);
                }
            },
            toggleGant(id) {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                    return;
                }
                if(!this.gantt_editing){
                    this.gantt_editing = id
                } else if(this.gantt_editing !== id){
                    this.gantt_editing = id
                } else{
                    this.gantt_editing = false
                }
            },
            completeForm() {
                this.$refs.titleObserver.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.disableSaveButton = true;
                            let activitiesSend = {
                                activities: {
                                    activities: this.activities,
                                    checked: this.completed
                                }
                            }
                            this.$store.dispatch('m3Sketch/saveAllDataProjectPart', activitiesSend)
                                .then((firstResponse) => {
                                    this.$toast.success(firstResponse.data)
                                    this.$store.dispatch('m3Sketch/syncGantt')
                                        .then(() => {
                                            this.disableSaveButton = false;
                                        });
                                    this.gantt_editing = null
                                    this.buildGantt();
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }
                    }
                    if(this.checks.activitati !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'activitati', value: this.completed })
                })
            },
            checkIdsDuplicated(){
                let usedIds = [];
                this.activities.forEach(activity => {
                    let parentChanged = false;
                    if(!activity.id){
                        while(usedIds.includes(this.nextId)){
                            this.nextId++;
                        }
                        activity.id = this.nextId;
                        usedIds.push(this.nextId);
                        this.nextId++;
                    }
                    else{
                        if(usedIds.includes(activity.id)){
                            while(usedIds.includes(this.nextId)){
                                this.nextId++;
                            }
                            activity.id = this.nextId;
                            usedIds.push(this.nextId);
                            this.nextId++;
                            parentChanged = true
                        }
                        else {
                            usedIds.push(activity.id)
                        }
                    }

                    activity.childrens.forEach(child => {
                        if(!child.id){
                            child.id = this.nextId;
                            child.parentId = activity.id;
                            this.nextId ++;

                            while(usedIds.includes(this.nextId)){
                                this.nextId++;
                            }
                            child.id = this.nextId;
                            child.parentId = activity.id;
                            usedIds.push(this.nextId);
                            this.nextId ++;
                        }
                        else {
                            if(usedIds.includes(child.id)){
                                while(usedIds.includes(this.nextId)){
                                    this.nextId++;
                                }
                                child.id = this.nextId;
                                usedIds.push(this.nextId);
                                this.nextId++;
                            }
                            else {
                                usedIds.push(child.id)
                            }
                            if(parentChanged){
                                child.parentId = activity.id
                            }
                        }
                    })
                })
            },
            getNewActivityId(){
                this.nextId ++;

                return (this.nextId - 1)
            },
            addActivity(){
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                    return;
                }

                let newId = this.getNewActivityId();
                let childId = this.getNewActivityId();

                this.$toast.success('Activitatea a fost adăugată cu succes! Nu uita să modifici numele acesteia.')
                if(this.activities.length){
                    this.activities.push({
                        id: newId,
                        title: 'Te rugăm să modifici acest text.',
                        number: this.activities.length + 1,
                        childrens: [
                            {
                                id: childId,
                                title: 'Te rugăm să modifici acest text.',
                                number: 1,
                                date: [5,14],
                                parentId: newId
                            },
                        ]
                    })
                } else{
                    this.activities.push({
                        id: this.getNewActivityId(),
                        title: 'Te rugăm să modifici acest text.',
                        number: 1,
                        childrens: [
                            {
                                id: this.getNewActivityId(),
                                title: 'Te rugăm să modifici acest text.',
                                number: 1,
                                date: [5,14],
                                parentId: 0
                            },
                        ]
                    })
                }
                this.buildGantt()
                // Warning: Never try this at home!!!
                document.getElementById('scrollAuxiliary').style.display = 'block';
                this.$refs.scrollActivity.scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
                document.getElementById('scrollAuxiliary').style.display = 'none';
                this.editing.activitate = this.activities.length - 1
                setTimeout(() => {
                    document.getElementById('inputActivity-' + newId).focus();
                }, 300);
            },
            addActivityChild(id){
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                    return;
                }
                let item = this.activities.find(activity => { return activity.id === id})
                let lastChilds = item.childrens[item.childrens.length -1]


                if(item.childrens.length === 0) {
                    item.childrens.push({
                        id: this.getNewActivityId(),
                        title: 'Te rugăm să modifici acest text.',
                        number: 1,
                        date: [5,14],
                        parentId: item.id,
                        purple: item.purple ? true : null
                    });
                    return;
                }

                item.childrens.push({
                    id: this.getNewActivityId(),
                    title: 'Te rugăm să modifici acest text.',
                    number: lastChilds.number+1,
                    date: [5,14],
                    parentId: item.id,
                    purple: item.purple ? true : null
                })
            },
            deleteActivity(event){
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                    return;
                }

                if(event.parent){
                    let removeIndex = this.activities.findIndex( item => item.id === event.id );
                    let removeItem = this.activities.filter( item => item.id === event.id );


                    let nextItems = this.activities.filter(item => {
                        return item.id > removeItem[0].id
                    })
                    nextItems.forEach((val, index) => nextItems[index].number = nextItems[index].number-1);

                    this.activities.splice( removeIndex, 1 );
                } else{
                    let removeIndex = this.activities[event.parentKey].childrens.findIndex( item => item.id === event.id );
                    let removeItem = this.activities[event.parentKey].childrens.filter( item => item.id === event.id );


                    let nextItems = this.activities[event.parentKey].childrens.filter(item => {
                        return item.id > removeItem[0].id
                    })
                    nextItems.forEach((val, index) => nextItems[index].number = nextItems[index].number-1);

                    this.activities[event.parentKey].childrens.splice( removeIndex, 1 );
                }

                this.buildGantt()
            },

            innovativeProductExists() {
                return this.activities.find((activity) => {
                    return activity.childrens.find((subactivity) => {
                        return subactivity.title === "Lansarea unui produs / serviciu nou - inovativ";
                    });
                }) !== undefined;
            },

            addInnovativeProductSubactivity() {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                    return;
                }

                if(this.activities.length === 0) {
                    this.activities.push({ id: this.getNewActivityId(), title: 'MANAGEMENTUL PROIECTULUI', number: 1, childrens: [] });
                }

                let activity = this.activities.find((activity) => {
                    return activity.title === "MANAGEMENTUL PROIECTULUI";
                })

                activity = activity ? activity : this.activities[0];

                activity.childrens.push({
                    id: this.getNewActivityId(),
                    title: 'Lansarea unui produs / serviciu nou - inovativ',
                    number: activity.childrens.length > 0 ? activity.childrens[activity.childrens.length - 1].number+1 : 1,
                    date: [5,14],
                    parentId: activity.id
                })
            }
        }
    }
</script>

<style scoped>
.flexed-warn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.flexed-warn .add-button{
    max-width: 145px;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.data-group{
    margin: auto;
    width: 90%;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.adauga-asociat{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.adauga-asociat .title{
    font-size: 14px;
    color: #515679;
}
.yellow-warning {
    font-size: 12px;
    color: #525d6e;
    background: #ffeebb;
    padding: 15px 30px;
    display: flex;
    align-items: center;
}
.yellow-warning img {
    margin-right: 20px;
}
.yellow-warning a {
    text-decoration: none;
}
.activitate{
    margin-top: 30px;
}
.activitate .header{
    background: #e9eaec;
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.purple{
    background: #e6cfea !important;
}
.purple{
    background: #f4e5f7 !important;
}
.activitate .header span{
    color: #515679;
}
.activitate .actions svg:not(:last-child){
    margin-right: 10px;
}
.activitate .actions svg{
    color: #9da1af;
    cursor: pointer;
}
.activitate .actions svg:hover{
    color: #7f838f;
}
.sub-item{
    margin-left: 90px;
    margin-top: 10px;
    background: #f8f9f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 30px;
}
.sub-item-margin{
    margin-left: 90px;
    margin-top: 3px;
    background: #f8f9f9;
    padding: 8px 30px;
    transition: 0.4s;
}
.gantt-slider p{
    font-size: 15px;
    color: #515679;
}
.visible-gantt{
    min-height: 120px;
    max-height: 130px;
    transition: 0.4s;
}
.gantt-active{
    color: #5cd2b1 !important;
}
.invisible-gantt{
    max-height: 0;
    padding: 0 30px !important;
    min-height: 0;
    transition: 0.4s;
}
.sub-item-margin >>> .slider-tooltip::before{
    display: none;
}
.sub-item-margin >>> .slider-dot-handle{
    outline: 4px solid #03c0b5;
}
.sub-item-margin >>> .slider-process{
    background-color: #515679 !important;
    min-height: 10px;
    top: -2.5px !important;
}
.sub-item-margin >>> .slider-component{
    margin-top: 15px;
}
.sub-item-margin >>> .slider{
    padding-top: 1px;
    border-bottom: 2px solid #9da1af;
    height: 2px !important;
}
.sub-item-margin >>> .piecewise-label{
    left: 27px !important;
    font-size: 13px !important;
    font-weight: 600;
    color: #515679 !important;
}
.sub-item-margin >>> .piecewise-item{
    background: #515679 !important;
    border-radius: 50%;
    opacity: 0.9;
    top: -1px !important;
}
.sub-item-margin >>> .piecewise-item:last-child{
    display: none !important;
}
.green{
    margin-left: 90px;
    margin-top: 10px;
    background: #cdfaee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 30px;
}
.sub-item .title{
    font-size: 14px;
    color: #515679;
}
.sub-item >>> input{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
    width: 60%;
}
.adauga-asociat{
    margin-top: -20px;
}
.add-button{
    margin-top: 0 !important;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
input:focus{
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.fixed-width{
    width: 80%;
}
.fixed-width strong{
    width: 18%;
    justify-content: space-between;
}
.fixed-width-small{
    width: 80%;
}
.fixed-width-small strong{
    width: 8%;
}
.number-input{
    padding: 0;
    text-align: center;
    margin: 0 10px;
    height: 33px;
}
.fixed-width span{
    max-height: 33px;
    margin-right: 10px;
    margin-left: 7px;
}
.text-danger{
    position: absolute;
    right: 40px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
}
.pointer-none{
    pointer-events: none;
    opacity: 0.5;
}
.error-input-custom{
    width: 100%;
    display: flex;
    align-items: center;
}
.error-input-custom >>> input{
    min-width: 262px;
    margin-right: 10px;
}
.button-absolute{
  position: absolute;
  top: 30px;
  right: 130px;
  z-index:3;
}
@media (max-width: 1950px){
  .button-absolute{
    position: absolute;
    top: 30px;
    right: 110px;
    z-index:3;
  }
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px !important;
    }
  .button-absolute{
    position: absolute;
    top: 15px;
    right: 60px;
  }
  .add-button{
    margin-top: 15px !important;
  }
  .adauga-asociat{
    flex-direction: column;
    align-items: inherit;
  }
}
@media screen and (max-width: 1536px) {
  .adauga-asociat{
    flex-direction: row;
    align-items: flex-end;
  }
}
@media (max-width: 1250px){
    .actions{
        display: flex;
    }
}
@media screen and (max-width:1100px){
    .data-group .title h2 {
        text-align: left;
    }
}
</style>
